import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

import Hero from '@components/Hero/Hero';

export const FoundationsWebinarDIV = styled.div`
  position: relative;

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    z-index: -1;
    width: 100vw;
  }

  &::before {
    top: 0;
    right: 0;
    width: 100vw;
    max-width: 1800px;
    height: 818px;
    background:
      right top
      no-repeat
      linear-gradient(203deg, rgba(123, 231, 235, 0.4) 0, rgba(255, 255, 255, 0) 56%);
  }

  &::after {
    bottom: 0;
    left: 0;
    width: 100vw;
    max-width: 1800px;
    height: 100%;
    background:
      left bottom
      no-repeat
      linear-gradient(20deg, rgba(123, 231, 235, 0.15) 5.12%, rgba(255, 255, 255, 0) 20%);
  }

  .rake {
    display: none !important;
    position: absolute !important;
    z-index: -1;
    
    &.rake-1 {
      top: 22px;
      left: 0;
      transform: scale(0.6);
      transform-origin: left center;
    }

    &.rake-2 {
      bottom: 0;
      right: 0;
    }

    ${MEDIA_QUERIES.L} {
      &.rake-1 {
        display: block !important;
      }
    }

    ${MEDIA_QUERIES.XL} {
      &.rake-1 {
        transform: none;
      }

      &.rake-2 {
        display: block !important;
      }
    }
  }
`;

export const FoundationsWebinarHERO = styled(Hero)`
  padding: calc(var(--SiteNav--height) + var(--spacing--L)) 0 var(--spacing--XL);
  margin-bottom: var(--spacing--XL);

    ${MEDIA_QUERIES.L} {
      margin-bottom: var(--spacing--M);
    }
`;

export const FoundationsWebinarHeroContentDIV = styled.div`
  h3 {
    color: var(--color--charcoal-700);
    margin: 0 0 20px;
  }

  h1 {
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.02em;
    color: var(--color--cobalt-700);
    margin: 0 0 30px;
    white-space: nowrap;


    span {
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        display: block;
        width: 100%;
        padding-bottom: 10.7%;
        position: absolute;
        bottom: -27%;
        z-index: -1;
        background: url("/images/pages/webinars/foundations-of-great-service/FoundationsWebinar--hero--underline.png");
        background-size: cover;
      }
    }
  }

  p {
    color: var(--color--charcoal-700);
    margin: 0 0 35px;

    &.small {
      color: var(--color--text-light);
      margin-top: 18px;
    }
  }
`;

export const FoundationsWebinarHeroVideoDIV = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  ${MEDIA_QUERIES.L} {
    justify-content: flex-end;
  }

  > div {
    position: relative;
    max-width: 720px;

    ${MEDIA_QUERIES.L} {
      margin: 16px 35px 0;
    }
  }

  video {
    border-radius: 4px;
  }

  .bottom-left,
  .bottom-right {
    position: absolute !important;
    bottom: 0;
  }

  .bottom-left {
    left: 0;
    width: 37%;
    max-width: 183px;
    transform: translate(-50%, 15%);
  }

  .bottom-right {
    right: 0;
    width: 115%;
    max-width: 576px;
    transform: translate(42%, 34%);
  }
`;

export const FoundationsWebinarClassesDIV = styled.div`
  h2 {
    text-align: center;
    margin-bottom: var(--spacing--M);
  }
`;

export const FoundationsWebinarClassesGridDIV = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing--M);
  margin-bottom: var(--spacing--L);

  ${MEDIA_QUERIES.S} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${MEDIA_QUERIES.M} {
  }

  ${MEDIA_QUERIES.L} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FoundationsWebinarClassDIV = styled.div`
  .gatsby-image-wrapper {
    margin-bottom: 20px;
  }

  h3 {
    display: block;
    color: var(--color--cobalt-500);
  }

  h6 {
    margin: var(--spacing--XS) 0 var(--spacing--base-0-75);
  }

  p {
    color: var(--color--charcoal-700);
  }
`;

export const FoundationsWebinarSignupDIV = styled.div`
  padding: 80px 0 30px;
`;

export const FoundationsWebinarSignupContentDIV = styled.div`
  padding-top: var(--spacing--M);
  margin-bottom: 30px;

  h2 {
    max-width: 17ch;
    text-wrap: balance;
  }
  ${MEDIA_QUERIES.M} {
    margin-bottom: 0;
  }
`;

export const FoundationsWebinarSignupImageDIV = styled.div`
  .gatsby-image-wrapper {
    max-width: 640px;
    margin: 0 auto;

    ${MEDIA_QUERIES.M} {
      margin: 0 0 0 30px;
    }

    ${MEDIA_QUERIES.L} {
      margin-left: 60px;
    }
  }
`;
